import { GlobalFilter } from '../global/GlobalFilter';
import { Notification } from './Notification';
export class NotificationsSearchModel extends GlobalFilter {
  pageData!: Notification[];
  unSeenNotificationsCount!: number;
  totalCount!: number;
}
